import type {z} from "zod";
import {SetCustomerOfferCoefficientBody} from "@project/sdk/sales/zod";

export const setCustomerOfferCoefficientFormSchema = SetCustomerOfferCoefficientBody.strict();
export type SetCustomerOfferCoefficientFormPayload = z.output<
  typeof setCustomerOfferCoefficientFormSchema
>;
export const draftSetCustomerOfferCoefficientFormSchema =
  setCustomerOfferCoefficientFormSchema.partial();
export type DraftSetCustomerOfferCoefficientFormPayload = z.output<
  typeof draftSetCustomerOfferCoefficientFormSchema
>;
